exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".svg-icon[data-v-3d1aa2f4]{width:1em;height:1em;vertical-align:-.15em;//fill:currentColor;overflow:hidden}", ""]);

// exports
